/**
 * Цель года (core-loop-v2 §4): одна строка под состояниями — «Цель года:
 * накопить 300 $», выполненная — с пометкой «выполнена» (`goalDone`
 * движка; запись в журнал и +2 счастья ставит тик). Без цели ничего не
 * рисуется. Сдержанно: без полосок и цвета-оценки, пометка — словом.
 */
import { goalDone, type Life } from '@life/engine';
import { t } from '@life/i18n';

export function GoalLine({ life }: { life: Life }) {
  const goal = life.yearGoal;
  if (goal === null) return null;
  const done = goalDone(goal, life);
  return (
    <p class={done ? 'goal-line done' : 'goal-line'}>
      <span>{t(goal.key, goal.params)}</span>
      {done && <span class="mono goal-done"> — {t('ui.goal.done')}</span>}
    </p>
  );
}
